import { defineEvent } from '../types/event';
export var COUPON_MODAL_CONTINUE_SHOPPING_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
